const _config = {
  maxUploadFileSize: process.env.FILE_SIZE_UPLOAD_LIMIT_BYTES,
  contentServiceMaxUploadFileSize: process.env.CONTENT_SERVICE_MAX_UPLOAD_FILE_SIZE_BYTES,
  bitrixWidgetUrl: process.env.BITRIX_WIDGET_URL,
  bitrixWidgetEmailPrefix: process.env.BITRIX_WIDGET_EMAIL_PREFIX,
  bitrixWidgetEnabled: process.env.BITRIX_WIDGET_ENABLED,
  supportPageMode: process.env.SUPPORT_PAGE_MODE,
  analyticsPageEnabled: process.env.ANALYTICS_PAGE_ENABLED,
  orderReconciliationEnabled: process.env.ORDER_RECONCILIATION_ENABLED,
  yandexMetrikaEnabled: process.env.YANDEX_METRIKA_ENABLED,
  yandexMetrikaId: process.env.YANDEX_METRIKA_ID
};

type Config = {
  maxUploadFileSize: number;
  contentServiceMaxUploadFileSize: number;
  bitrixWidgetUrl: string;
  bitrixWidgetEmailPrefix: string;
  bitrixWidgetEnabled: boolean;
  supportPageMode: 'FORM' | 'FAQ';
  analyticsPageEnabled: boolean;
  orderReconciliationEnabled: boolean;
  yandexMetrikaEnabled: boolean;
  yandexMetrikaId: string;
};

const configTypeMap = {
  maxUploadFileSize: 'number',
  contentServiceMaxUploadFileSize: 'number',
  bitrixWidgetUrl: 'string',
  bitrixWidgetEmailPrefix: 'string',
  bitrixWidgetEnabled: 'boolean',
  supportPageMode: 'string',
  analyticsPageEnabled: 'boolean',
  orderReconciliationEnabled: 'boolean',
  yandexMetrikaEnabled: 'boolean',
  yandexMetrikaId: 'string'
};

export const getConfigValue = <T extends keyof Config>(key: T): Config[T] => {
  const type = configTypeMap[key];
  if (type === 'number') {
    return +(_config[key] || 0) as Config[T];
  }

  if (type === 'string') {
    return String(_config[key]) as Config[T];
  }

  if (type === 'boolean') {
    return (_config[key] === 'true') as Config[T];
  }

  return _config[key] as Config[T];
};
